import React from 'react';
import { Colors } from '../Constants/colors';

export const Separator = () => {
  return (
    <div
      style={{
        backgroundColor: `${Colors.LightAshRose}`,
        height: '1px',
      }}
    />
  );
};
